export const colors = {  
  primary: {
    0: "#FFFFFF",
    50: "#E6FBFF",
    100: "#CCF7FE",
    200: "#99EEFD",
    300: "#66E6FC",
    400: "#33DDFB",
    500: "#00D5FA",
    600: "#00A0BC",
    700: "#006B7D",
    800: "#00353F",
    900: "#1F2A40",
    1000: "#141b2d",
  },
  grey: {
    0: "#FFFFFF",
    10: "#F6F6F6",
    50: "#F0F0F0",
    100: "#E0E0E0",
    200: "#C2C2C2",
    300: "#A3A3A3",
    400: "#858585",
    500: "#666666",
    600: "#4D4D4D",
    700: "#333333",
    800: "#1A1A1A",
    900: "#0A0A0A",
    1000: "#000000",
  },
  slate: {
    0: "#FFFFFF",
    50: "#F8FAFC",
    100: "#F1F5F9",
    200: "#E2E8F0",
    300: "#CBD5E1",
    400: "#94A3B8",
    500: "#64748B",
    600: "#475569",
    700: "#334155",
    800: "#1E293B",
    900: "#0F172A",
    1000: "#020617",
  },
  amber: {
    0: "#FFFFFF",
    50: "#FFFBEB",
    100: "#FEF3C7",
    200: "#FDE68A",
    300: "#FCD34D",
    400: "#FBBF24",
    500: "#F59E0B",
    600: "#D97706",
    700: "#B45309",
    800: "#92400E",
    900: "#78350F",
    1000: "#2B1606",
  },
  yellow: {
    0: "#FFFFFF",
    50: "#FFFDE7",
    100: "#FFF9C4",
    200: "#FFF59D",
    300: "#FFF176",
    400: "#FFEE58",
    500: "#FFEB3B", 
    600: "#FDD835",
    700: "#FBC02D",
    800: "#F9A825",
    900: "#F57F17",
    1000: "#3A2A00",
  },
  orange: {
    0: "#FFFFFF",
    50: "#FFF3E0",
    100: "#FFE0B2",
    200: "#FFCC80",
    300: "#FFB74D",
    400: "#FFA726",
    500: "#FF9800",
    600: "#FB8C00",
    700: "#F57C00",
    800: "#EF6C00",
    900: "#E65100",
    1000: "#3A1E00",
  },    
  red: {
    0: "#FFFFFF",
    50: "#FFF1F1",
    100: "#FFD6D6",
    200: "#FFB3B3",
    300: "#FF8080",
    400: "#FF4D4D",
    500: "#FF1F1F", 
    600: "#E60000",
    700: "#B30000",
    800: "#800000",
    900: "#4D0000",
    1000: "#260000",
  },
  rose: {
    0: "#FFFFFF",
    50: "#FFF0F3",
    100: "#FFE0E6",
    200: "#FFC2D1",
    300: "#FF9BB3",
    400: "#FF7096",
    500: "#FF4D7E",
    600: "#F63366",
    700: "#E11D48",
    800: "#C9183A",
    900: "#A5112D",
    1000: "#5C0A18",
  },
  green: {
    0: "#FFFFFF",
    50: "#EDFDF8",
    100: "#dbf5ee",
    200: "#b7ebde",
    300: "#94e2cd",
    400: "#70d8bd",
    500: "#4cceac",
    600: "#3da58a",
    700: "#2e7c67",
    800: "#1e5245",
    900: "#0f2922",
    1000: "#081814",
  },
  blue: {
    0: "#FFFFFF",
    50: "#EFF0FF",
    100: "#e1e2fe",
    200: "#c3c6fd",
    300: "#a4a9fc",
    400: "#868dfb",
    500: "#6870fa",
    600: "#535ac8",
    700: "#3e4396",
    800: "#2a2d64",
    900: "#151632",
    1000: "#0B0B19",
  },
  indigo: {
    0: "#FFFFFF",
    50: "#E8EAF6",
    100: "#C5CAE9",
    200: "#9FA8DA",
    300: "#7986CB",
    400: "#5C6BC0",
    500: "#3F51B5",
    600: "#3949AB",
    700: "#303F9F",
    800: "#283593",
    900: "#1A237E",
    1000: "#0D102A",
  },
  purple: {
    0: "#FFFFFF",
    50: "#F3E5F5",
    100: "#E1BEE7",
    200: "#CE93D8",
    300: "#BA68C8",
    400: "#AB47BC",
    500: "#9C27B0",
    600: "#8E24AA",
    700: "#7B1FA2",
    800: "#6A1B9A",
    900: "#4A148C",
    1000: "#1F082E",
  }, 
};


export const themeSettings = (mode) => {
  return {
    palette: {
      mode: mode,
      ...(mode === "dark" 
      ? { 
          primary: {
            lightest: colors.primary[900],
            light: colors.primary[700], 
            mid: colors.primary[600],
            main: colors.primary[500],
            deep: colors.primary[400],
            dark: colors.primary[300], 
            darkest: colors.primary[100],
          },
          neutral: {
            lightest: colors.grey[900],
            light: colors.grey[700],
            mid: colors.grey[600],
            main: colors.grey[500],
            deep: colors.grey[400],
            dark: colors.grey[300],
            darkest: colors.grey[100],
          },
          slate: {
            lightest: colors.slate[900],
            light: colors.slate[700],
            mid: colors.slate[600],
            main: colors.slate[500],
            deep: colors.slate[400],
            dark: colors.slate[300],
            darkest: colors.slate[100],
          },
          amber: {
            lightest: colors.amber[900],
            light: colors.amber[700],
            mid: colors.amber[600],
            main: colors.amber[500],
            deep: colors.amber[400],
            dark: colors.amber[300],
            darkest: colors.amber[100],
          },
          yellow: {
            lightest: colors.yellow[900],
            light: colors.yellow[700],
            mid: colors.yellow[600],
            main: colors.yellow[500],
            deep: colors.yellow[400],
            dark: colors.yellow[300],
            darkest: colors.yellow[100],
          },
          orange: {
            lightest: colors.orange[900],
            light: colors.orange[700],
            mid: colors.orange[600],
            main: colors.orange[500],
            deep: colors.orange[400],
            dark: colors.orange[300],
            darkest: colors.orange[100],
          },
          red: {
            lightest: colors.red[900],
            light: colors.red[700],
            mid: colors.red[600],
            main: colors.red[500],
            deep: colors.red[400],
            dark: colors.red[300],
            darkest: colors.red[100],
          },
          rose: {
            lightest: colors.rose[900],
            light: colors.rose[700],
            mid: colors.rose[600],
            main: colors.rose[500],
            deep: colors.rose[400],
            dark: colors.rose[300],
            darkest: colors.rose[100],
          },
          green: {
            lightest: colors.green[900],
            light: colors.green[700],
            mid: colors.green[600],
            main: colors.green[500],
            deep: colors.green[400],
            dark: colors.green[300],
            darkest: colors.green[100],
          },
          blue: {
            lightest: colors.blue[900],
            light: colors.blue[700],
            mid: colors.blue[600],
            main: colors.blue[500],
            deep: colors.blue[400],
            dark: colors.blue[300],
            darkest: colors.blue[100],
          },
          indigo: {
            lightest: colors.indigo[900],
            light: colors.indigo[700],
            mid: colors.indigo[600],
            main: colors.indigo[500],
            deep: colors.indigo[400],
            dark: colors.indigo[300],
            darkest: colors.indigo[100],
          },
          purple: {
            lightest: colors.purple[900],
            light: colors.purple[700],
            mid: colors.purple[600],
            main: colors.purple[500],
            deep: colors.purple[400],
            dark: colors.purple[300],
            darkest: colors.purple[100],
          },
          background: {
            default: colors.grey[900],
            alt: colors.grey[800],
          },
        }
      : {     
          primary: {
            lightest: colors.primary[100],
            light: colors.primary[300],
            mid: colors.primary[400],
            main: colors.primary[500],
            deep: colors.primary[600],
            dark: colors.primary[700],
            darkest: colors.primary[900],
          },
          neutral: {
            lightest: colors.grey[100],
            light: colors.grey[300],
            mid: colors.grey[400],
            main: colors.grey[500],
            deep: colors.grey[600],
            dark: colors.grey[700],
            darkest: colors.grey[900],
          },
          slate: {
            lightest: colors.slate[100],
            light: colors.slate[300],
            mid: colors.slate[400],
            main: colors.slate[500],
            deep: colors.slate[600],
            dark: colors.slate[700],
            darkest: colors.slate[900],
          },
          amber: {
            lightest: colors.amber[100],
            light: colors.amber[300],
            mid: colors.amber[400],
            main: colors.amber[500],
            deep: colors.amber[600],
            dark: colors.amber[700],
            darkest: colors.amber[900],
          },
          yellow: {
            lightest: colors.yellow[100],
            light: colors.yellow[300],
            mid: colors.yellow[400],
            main: colors.yellow[500],
            deep: colors.yellow[600],
            dark: colors.yellow[700],
            darkest: colors.yellow[900],
          },
          orange: {
            lightest: colors.orange[100],
            light: colors.orange[300],
            mid: colors.orange[400],
            main: colors.orange[500],
            deep: colors.orange[600],
            dark: colors.orange[700],
            darkest: colors.orange[900],
          },
          red: {
            lightest: colors.red[100],
            light: colors.red[300],
            mid: colors.red[400],
            main: colors.red[500],
            deep: colors.red[600],
            dark: colors.red[700],
            darkest: colors.red[900],
          },
          rose: {
            lightest: colors.rose[100],
            light: colors.rose[300],
            mid: colors.rose[400],
            main: colors.rose[500],
            deep: colors.rose[600],
            dark: colors.rose[700],
            darkest: colors.rose[900],
          },
          green: {
            lightest: colors.green[100],
            light: colors.green[300],
            mid: colors.green[400],
            main: colors.green[500],
            deep: colors.green[600],
            dark: colors.green[700],
            darkest: colors.green[900],
          },            
          blue: {
            lightest: colors.blue[100],
            light: colors.blue[300],
            mid: colors.blue[400],
            main: colors.blue[500],
            deep: colors.blue[600],
            dark: colors.blue[700],
            darkest: colors.blue[900],
          },
          indigo: {
            lightest: colors.indigo[100],
            light: colors.indigo[300],
            mid: colors.indigo[400],
            main: colors.indigo[500],
            deep: colors.indigo[600],
            dark: colors.indigo[700],
            darkest: colors.indigo[900],
          },
          purple: {
            lightest: colors.purple[100],
            light: colors.purple[300],
            mid: colors.purple[400],
            main: colors.purple[500],
            deep: colors.purple[600],
            dark: colors.purple[700],
            darkest: colors.purple[900],
          },
          background: {
            default: colors.grey[10],
            alt: colors.grey[50],
          },
        }
      ),
    },
    typography: {
      fontFamily: ["Rubik", "sans-serif"].join(","),
      fontSize: 12,
      h1: {
        fontFamily: ["Rubik", "sans-serif"].join(","),
        fontSize: 40,
      },
      h2: {
        fontFamily: ["Rubik", "sans-serif"].join(","),
        fontSize: 32,
      },
      h3: {
        fontFamily: ["Rubik", "sans-serif"].join(","),
        fontSize: 24,
      },
      h4: {
        fontFamily: ["Rubik", "sans-serif"].join(","),
        fontSize: 20,
      },
      h5: {
        fontFamily: ["Rubik", "sans-serif"].join(","),
        fontSize: 16,
      },
      h6: {
        fontFamily: ["Rubik", "sans-serif"].join(","),
        fontSize: 14,
      },
    },
  };
};
